<script setup>
import { SecondaryButton } from '@codinglabsau/ui'

defineProps({
  collection: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <div class="flex flex-col items-center space-y-2 border-t border-gray-200 pt-2">
    <span class="text-xs text-gray-400">
      Showing
      <span class="font-medium">{{ collection.from }}</span>
      to
      <span class="font-medium">{{ collection.to }}</span>
      of
      <span class="font-medium">{{ collection.total }}</span>
      results
    </span>
    <nav class="flex items-center justify-between bg-white py-3" aria-label="Pagination">
      <div
        class="flex flex-1 items-center"
        :class="[
          !collection.prev_page_url || !collection.next_page_url
            ? 'justify-center space-x-2'
            : 'justify-between',
        ]"
      >
        <SecondaryButton v-if="collection.prev_page_url" :href="collection.prev_page_url">
          Previous
        </SecondaryButton>
        <div class="mx-2">
          <p class="text-sm text-gray-700">
            <span class="font-medium">{{ collection.current_page }}</span>
            /
            <span class="font-medium">{{ collection.last_page }}</span>
          </p>
        </div>
        <SecondaryButton v-if="collection.next_page_url" :href="collection.next_page_url">
          Next
        </SecondaryButton>
      </div>
    </nav>
  </div>
</template>
